module.exports = __webpack_public_path__ + "static/codetile-216576c7270e434ed2c6936968752ee6.jpg";